function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_7)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M547.349 513.023C564.895 513.023 579.46 517.346 591.042 525.99V563.658C586.957 560.365 582.19 557.689 576.751 555.631C571.312 553.572 565.497 552.543 559.281 552.543C548.402 552.543 539.905 554.866 533.762 559.541C527.62 564.217 524.54 570.303 524.54 577.86C524.54 585.27 527.52 591.328 533.487 596.092C539.455 600.826 548.101 603.207 559.455 603.207C565.296 603.207 571.063 602.207 576.751 600.238C582.418 598.238 587.306 595.798 591.391 592.915V629.348C578.534 638.405 563.619 642.933 546.646 642.933C532.36 642.874 520.176 639.993 510.123 634.229C500.075 628.466 492.477 620.644 487.414 610.764C482.351 600.884 479.795 589.769 479.795 577.419C479.795 565.07 482.425 554.013 487.689 544.28C492.954 534.547 500.673 526.902 510.853 521.345C521.027 515.787 533.186 513.023 547.349 513.023ZM415.565 512.995C425.39 512.995 434.39 514.23 442.59 516.7C450.786 519.17 457.553 522.316 462.944 526.168V558.484C457.427 554.632 451.109 551.603 443.892 549.309C436.697 547.046 429.305 545.928 421.681 545.928C410.676 545.928 405.189 548.133 405.189 552.515C405.189 554.573 406.041 556.102 407.745 557.131C409.449 558.16 412.581 559.219 417.12 560.337L434.665 564.041C446.125 566.365 454.67 570.452 460.284 576.274C465.902 582.096 468.707 590.712 468.707 602.121C468.707 614.617 464.072 624.527 454.77 631.878C445.469 639.229 432.284 642.905 415.189 642.905C405.137 642.876 395.364 641.435 385.888 638.553C376.412 635.672 367.862 631.496 360.269 625.997V591.829C366.01 597.033 373.703 601.327 383.354 604.708C393.004 608.06 402.332 609.736 411.353 609.736C415.565 609.736 418.75 609.09 420.904 607.796C423.062 606.502 424.141 604.944 424.141 603.15C424.141 601.092 423.564 599.386 422.385 598.004C421.205 596.622 418.925 595.475 415.543 594.505L394.486 588.947C382.428 585.654 373.878 581.096 368.793 575.245C363.703 569.422 361.169 561.777 361.169 552.309C361.169 544.34 363.375 537.43 367.84 531.52C372.275 525.61 378.592 521.052 386.788 517.846C394.988 514.612 404.56 512.995 415.565 512.995ZM985.823 490.559V638.759H942.83V611.795C939.195 621.939 933.681 629.673 926.263 634.966C918.841 640.229 909.666 642.876 898.788 642.876C889.063 642.876 880.592 640.112 873.344 634.554C866.101 628.997 860.513 621.381 856.577 611.707C852.667 602.032 850.683 591.094 850.683 578.862C850.561 566.247 852.64 554.926 856.926 544.899C861.19 534.872 867.228 527.051 875 521.434C882.772 515.818 891.645 512.995 901.597 512.995C921.725 512.995 935.338 523.077 942.461 543.212L942.828 544.278L942.83 490.559H985.823ZM670.702 512.965C684.617 512.965 696.622 515.7 706.675 521.199C716.727 526.697 724.399 534.225 729.663 543.84C734.928 553.456 737.558 564.483 737.558 576.98C737.558 589.329 734.928 600.504 729.663 610.53C724.399 620.557 716.701 628.438 706.574 634.201C696.447 639.965 684.49 642.846 670.68 642.846C656.866 642.846 644.909 639.994 634.808 634.23C624.681 628.467 616.962 620.587 611.645 610.56C606.333 600.533 603.65 589.359 603.65 577.009C603.65 564.659 606.306 553.632 611.645 543.958C616.984 534.284 624.655 526.697 634.734 521.199C644.782 515.7 656.792 512.965 670.702 512.965ZM341.073 546.721V639.405H298.21V546.721C311.343 553.367 327.639 553.661 341.073 546.721ZM827.022 515.67C833.212 515.67 838.529 517.317 842.99 520.61V565.07C838.529 561.63 832.762 559.924 825.619 559.924C816.266 559.924 809.049 563.247 804.033 569.892C798.996 576.538 796.488 586.888 796.488 600.885V638.758H753.499V518.346H795.615V556.631C797.943 542.634 801.731 532.313 806.943 525.638C812.133 518.993 818.848 515.67 827.022 515.67ZM207.431 494.675C223.928 494.675 237.864 497.704 249.297 503.732C260.7 509.76 269.25 518.17 274.916 528.932C280.578 539.694 283.435 552.014 283.435 565.893C283.435 579.478 280.478 591.799 274.562 602.826C268.647 613.882 259.647 622.615 247.541 629.055C235.435 635.494 220.442 638.729 202.521 638.729H139V494.675H207.431ZM670.68 550.897C663.183 550.897 657.316 553.338 653.03 558.219C648.771 563.101 646.639 569.629 646.639 577.862C646.639 586.095 648.771 592.711 653.03 597.71C657.294 602.709 663.183 605.238 670.68 605.238C678.046 605.208 683.865 602.709 688.125 597.71C692.389 592.711 694.543 586.095 694.543 577.862C694.543 569.629 692.411 563.071 688.125 558.219C683.865 553.338 678.046 550.897 670.68 550.897ZM919.142 551.515C911.899 551.515 906.11 553.956 901.772 558.837C897.434 563.718 895.28 570.04 895.28 577.862C895.28 585.684 897.434 592.064 901.772 597.004C906.11 601.944 911.824 604.414 918.967 604.414C926.211 604.385 932.026 601.885 936.416 596.887C940.803 591.888 942.983 585.39 942.983 577.45C942.983 569.776 940.851 563.512 936.591 558.719C932.327 553.927 926.486 551.515 919.142 551.515ZM204.299 531.313H182.892V602.12H201.817C212.923 602.12 221.473 598.856 227.436 592.358C233.404 585.83 236.388 576.95 236.388 565.688C236.388 555.249 233.727 546.927 228.415 540.693C223.102 534.46 215.055 531.313 204.299 531.313ZM319.661 486C331.496 486 341.095 496.11 341.095 508.582C341.095 521.055 331.496 531.165 319.661 531.165C307.822 531.165 298.228 521.055 298.228 508.582C298.228 496.11 307.822 486 319.661 486Z",
  fill: "#718EF7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.878 727.358C265.044 728.093 279.002 735.103 294.979 736.902C402.533 749.033 511.555 749.033 619.106 736.902C669.644 731.219 718.854 720.391 769.749 717.847C821.976 715.213 876.084 719.704 926.397 705.163C986.527 687.774 1030.06 642.249 1032.49 594.185C1034.82 548.354 1003.56 505.831 986.77 461.757C966.909 409.461 967.446 353.257 988.304 301.232C1009.27 248.981 1050.62 199.206 1046.75 144.752C1041.31 68.5492 930.105 7.12898 830.881 25.4817C778.911 35.0826 693.652 58.398 631.83 58.398C525.709 49.9618 501.876 22.2084 346.695 25.4817C273.3 31.7287 95.2545 40.9621 77.5989 118.511C62.5974 184.403 140.849 289.18 121.697 342.353C104.806 389.307 109.346 393.255 77.5989 435.704C54.3407 466.78 18.6773 493.698 8.25591 528.474C-3.95969 569.222 -40.2098 713.457 249.878 727.358Z",
  fill: "url(#paint0_linear_1_7)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M694.077 161.549C662.358 149.146 628.443 140.132 592.986 135C588.631 141.58 583.544 150.429 580.036 157.469C542.344 152.732 504.999 152.732 468 157.469C464.493 150.429 459.29 141.58 454.897 135C419.401 140.132 385.448 149.179 353.729 161.614C289.752 242.411 272.409 321.2 281.081 398.871C323.513 425.353 364.636 441.44 405.064 451.967C415.046 440.486 423.949 428.281 431.618 415.418C417.012 410.78 403.022 405.056 389.803 398.41C393.31 396.239 396.74 393.969 400.054 391.633C480.68 423.149 568.282 423.149 647.944 391.633C651.297 393.969 654.727 396.239 658.196 398.41C644.938 405.088 630.909 410.812 616.303 415.451C623.972 428.281 632.837 440.519 642.857 452C683.324 441.473 724.485 425.386 766.917 398.871C777.092 308.831 749.536 230.765 694.077 161.549ZM442.602 351.104C418.399 351.104 398.551 332.221 398.551 309.225C398.551 286.23 417.975 267.314 442.602 267.314C467.23 267.314 487.078 286.197 486.654 309.225C486.692 332.221 467.23 351.104 442.602 351.104ZM605.396 351.104C581.193 351.104 561.344 332.221 561.344 309.225C561.344 286.23 580.768 267.314 605.396 267.314C630.023 267.314 649.871 286.197 649.447 309.225C649.447 332.221 630.023 351.104 605.396 351.104Z",
  fill: "#718EF7",
  fillOpacity: 0.61
}), /*#__PURE__*/React.createElement("path", {
  d: "M873.73 218.957C873.27 219.239 872.754 219.521 872.295 219.859C861.159 226.456 848.245 229.67 835.215 229.445L823.219 229.219L736.833 221.72C735.743 221.607 735.054 220.536 735.398 219.521L765.074 139.51L769.953 128.684C775.233 117.012 783.671 106.863 794.462 99.758C794.921 99.4761 795.38 99.1378 795.839 98.8559C829.36 77.8805 873.787 87.4096 895.484 120C917.525 153.099 907.71 197.756 873.73 218.957Z",
  fill: "#D2D4E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M870.86 205.594C870.4 205.932 869.941 206.27 869.482 206.552C858.863 213.939 846.178 217.998 833.206 218.675L821.21 219.295L734.537 217.829C733.447 217.829 732.643 216.758 732.93 215.743L756.751 133.871L760.884 122.763C765.303 110.753 772.995 100.04 783.269 92.2024C783.728 91.864 784.13 91.5257 784.589 91.2438C816.56 68.013 861.561 74.3845 885.496 105.453C909.776 136.86 903.175 182.081 870.86 205.594Z",
  fill: "white",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M854.224 180.758C872.973 167.116 876.915 141.127 863.028 122.708C849.141 104.29 822.684 100.418 803.935 114.06C785.186 127.702 781.244 153.691 795.131 172.11C809.018 190.528 835.475 194.4 854.224 180.758Z",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M783.786 171.875C781.203 167.646 779.366 163.079 778.275 158.343",
  stroke: "#5F718E",
  strokeWidth: 4.51766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M777.471 153.381C777.357 152.084 777.242 150.73 777.242 149.434",
  stroke: "#5F718E",
  strokeWidth: 4.51766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M849.966 88.7628C854.271 90.1161 858.461 92.0332 862.365 94.5705",
  stroke: "#5F718E",
  strokeWidth: 4.51766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M781.891 193.245L785.795 195.613",
  stroke: "#5F718E",
  strokeWidth: 3.76469,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M781.604 189.806L789.296 194.655",
  stroke: "#5F718E",
  strokeWidth: 3.76469,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M786.885 189.862L789.009 191.159",
  stroke: "#5F718E",
  strokeWidth: 3.76469,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M824.137 46.8685V88.199C824.137 94.2887 819.143 99.1942 812.944 99.1942V113.854C812.944 114.644 812.026 115.151 811.337 114.7L786.369 99.1942H736.374C730.175 99.1942 725.181 94.2887 725.181 88.199V46.8685C725.181 40.7788 730.175 35.8733 736.374 35.8733H812.944C819.143 35.8733 824.137 40.8352 824.137 46.8685Z",
  fill: "white",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M733.634 71.3756H770.813",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M733.634 80.4557H752.223",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M733.634 62.4507H770.813",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M733.634 53.4482H770.813",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M808.352 88.2554H788.435C785.335 88.2554 782.81 85.7744 782.81 82.7296V54.1986C782.81 51.1537 785.335 48.6728 788.435 48.6728H808.352C811.452 48.6728 813.977 51.1537 813.977 54.1986V82.7296C813.92 85.7744 811.452 88.2554 808.352 88.2554Z",
  fill: "#EBEBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M798.709 63.615C801.023 63.615 802.899 61.7721 802.899 59.4988C802.899 57.2255 801.023 55.3827 798.709 55.3827C796.395 55.3827 794.519 57.2255 794.519 59.4988C794.519 61.7721 796.395 63.615 798.709 63.615Z",
  fill: "#FBF2ED",
  stroke: "#5F718E",
  strokeWidth: 7.03125,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M805.597 79.7976H791.764C791.305 79.7976 790.903 79.4029 790.903 78.9518V73.3133C790.903 69.3099 794.232 66.0396 798.307 66.0396H799.111C803.186 66.0396 806.515 69.3099 806.515 73.3133V78.9518C806.458 79.4029 806.114 79.7976 805.597 79.7976Z",
  fill: "#D3D5E7",
  stroke: "#5F718E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M730.232 45.7971C730.864 43.9928 732.184 42.4704 733.849 41.5682",
  stroke: "#5F718E",
  strokeWidth: 4.6875,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M852.664 184.393V225.667C852.664 231.756 857.658 236.662 863.857 236.662V251.322C863.857 252.112 864.775 252.619 865.464 252.168L890.432 236.662H940.484C946.683 236.662 951.677 231.756 951.677 225.667V184.393C951.677 178.303 946.683 173.397 940.484 173.397H863.857C857.658 173.397 852.664 178.359 852.664 184.393Z",
  fill: "white",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M942.195 222.89H924.15",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M942.195 213.113H906.045",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M942.195 203.503H906.045",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M942.195 193.809H906.045",
  stroke: "#5F718E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M868.506 225.78H888.424C891.523 225.78 894.049 223.299 894.049 220.254V191.723C894.049 188.678 891.523 186.197 888.424 186.197H868.506C865.407 186.197 862.881 188.678 862.881 191.723V220.254C862.881 223.299 865.407 225.78 868.506 225.78Z",
  fill: "#EBEBED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.149 201.139C880.463 201.139 882.339 199.296 882.339 197.023C882.339 194.75 880.463 192.907 878.149 192.907C875.835 192.907 873.959 194.75 873.959 197.023C873.959 199.296 875.835 201.139 878.149 201.139Z",
  fill: "#FBF2ED",
  stroke: "#5F718E",
  strokeWidth: 7.03125,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M871.204 217.322H885.037C885.496 217.322 885.898 216.927 885.898 216.476V210.837C885.898 206.834 882.569 203.564 878.494 203.564H877.69C873.615 203.564 870.286 206.834 870.286 210.837V216.476C870.343 216.927 870.745 217.322 871.204 217.322Z",
  fill: "#BDBDBD",
  fillOpacity: 0.27,
  stroke: "#5F718E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M901.683 221.945L905.701 224.426",
  stroke: "#5F718E",
  strokeWidth: 3.90625,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M901.396 218.393L909.374 223.355",
  stroke: "#5F718E",
  strokeWidth: 3.90625,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M906.849 218.393L909.03 219.803",
  stroke: "#5F718E",
  strokeWidth: 3.90625,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M857.887 182.645C858.519 180.84 859.839 179.318 861.504 178.416",
  stroke: "#5F718E",
  strokeWidth: 4.6875,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M921.6 114.193C916.664 113.967 916.779 108.554 916.779 108.554C916.664 114.475 911.728 114.193 911.728 114.193C911.728 114.193 916.779 114.644 916.779 119.662C916.779 119.719 917.41 114.7 921.6 114.193Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M911.9 104.607C903.347 104.156 903.577 94.8525 903.577 94.8525C903.347 105.115 894.795 104.607 894.795 104.607C894.795 104.607 903.577 105.453 903.577 114.136C903.577 114.136 904.725 105.453 911.9 104.607Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M921.428 92.8226C916.664 92.5971 916.779 87.4096 916.779 87.4096C916.664 93.1045 911.9 92.8226 911.9 92.8226C911.9 92.8226 916.779 93.2737 916.779 98.1228C916.779 98.0665 917.41 93.2737 921.428 92.8226Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M807.951 136.86C807.951 136.86 815.068 132.123 817.823 138.213C820.923 145.092 806.458 154.396 806.458 154.396H818.914",
  stroke: "#718EF7",
  strokeOpacity: 0.78,
  strokeWidth: 6.25,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M838.601 148.926H822.587L834.01 134.886V154.452",
  stroke: "#718EF7",
  strokeOpacity: 0.78,
  strokeWidth: 6.25,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M841.931 139.792V146.445V147.798V154.903",
  stroke: "#718EF7",
  strokeOpacity: 0.78,
  strokeWidth: 4.6875,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M849.852 154.903V149.885C849.852 147.742 848.072 145.994 845.891 145.994C843.71 145.994 841.931 147.742 841.931 149.885V152.084",
  stroke: "#718EF7",
  strokeOpacity: 0.78,
  strokeWidth: 4.6875,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1_7",
  x1: 1192.19,
  y1: -54.9166,
  x2: 1048.13,
  y2: 1039.07,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B8CAF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E9FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_7"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1047,
  height: 746,
  fill: "white"
})));

function SvgIconTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1047,
    height: 746,
    viewBox: "0 0 1047 746",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTest);
export default __webpack_public_path__ + "static/media/iconTest.8d8a398c.svg";
export { ForwardRef as ReactComponent };